import { render, staticRenderFns } from "./StopwatchSvg.vue?vue&type=template&id=c61c0668&"
import script from "./StopwatchSvg.vue?vue&type=script&lang=ts&"
export * from "./StopwatchSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports